import React from 'react';
import '../../styles/collaborators/collaborators.css';
import azLogo from '../../assets/img/astrazeneca-logo-png-astrazeneca-logo-astra-zeneca-4902.png';

const AzTeam = () => {

	return (
		<section className="azSection">
            <span className="text-content">
				<h2>Astra Zeneca Team</h2>
				<p>
					AstraZeneca will contribute to the project developing and testing cancer proteomics for disease monitoring as well as 
					generally navigating clinical proteomics use-cases in industry trials.
					<br/>
					<br/>
					AstraZeneca is a global, science-led biopharmaceutical company that focuses on the discovery, development, and 
					commercialisation of prescription medicines in Oncology, Rare Diseases, and BioPharmaceuticals, including Cardiovascular, 
					Renal & Metabolism, and Respiratory & Immunology. Based in Cambridge, UK, AstraZeneca’s innovative medicines are sold in 
					more than 125 countries and used by millions of patients worldwide. Please visit <a href="https://www.astrazeneca.com" target="_blank" rel="noopener noreferrer">astrazeneca.com</a> .
				</p>
			</span>
			<span className="logo-encasing">
				<img
					src={azLogo}
					alt="AZ Logo"
					className="azLogo"
				/>
			</span>
		</section>
	);
};

export default AzTeam;
